import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Link } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { connect } from "react-redux";
import { getTranslate, getActiveLanguage } from "react-localize-redux";
import antd from "antd";
import styled from "styled-components";

import routes, { RouteList } from "./routes.js";

import "./app.css";

const {
	Button,
	Layout,
	Layout: {
		Header,
		Content,
		Footer,
		Sider
	},
	Menu,
	Menu: {
		SubMenu,
		Item: MenuItem
	},
	Breadcrumb,
	Breadcrumb: {
		Item: BreadcrumbItem
	},
	Icon,
	Modal,
	Table
} = antd;

const StyledIcon = styled(Icon)`
	font-size: 18px;
	line-height: 64px;
	padding: 0 24px;
	cursor: pointer;
	transition: color .3s;
	&:hover {
		color: #1890ff;
	}
`;

const StyledButton = styled(Button)`
	position: absolute;
    z-index: 1;
    top: 20px;
    left: 220px;
	&.collapsed {
		left: 20px;
	}
`;

const TicketsButton = styled(Button)`
	position: absolute;
    z-index: 2;
    top: 20px;
	right: 20px;
`;

const ticketColumns = [
	{
		dataIndex: "name",
		key: "name"
	},
	{
		dataIndex: "date",
		key: "date"
	},
	{
		dataIndex: "time",
		key: "time"
	},
	{
		dataIndex: "location",
		key: "location"
	},
	{
		dataIndex: "buy",
		key: "buy",
		render: text => <a target="_blank" href={`https://konzerthaus.at/konzert/eventid/${text}`}>Ticket kaufen</a>,
	}
];

const tickets = [
	{
		key: "0",
		name: "Halbfinale 1",
		date: "15.05.",
		time: "18:00",
		location: "Berio-Saal",
		buy: "55633"
	},
	{
		key: "1",
		name: "Halbfinale 2",
		date: "15.05.",
		time: "20:00",
		location: "Berio-Saal",
		buy: "55634"
	},
	{
		key: "2",
		name: "Großes Finale",
		date: "16.05.",
		time: "19:30",
		location: "Berio-Saal",
		buy: "55635"
	}
];

/**
 *
 *
 * @class App
 * @extends {Component}
 * @param {boolean} collapsed
 * collapsed
 * @author [Nano Miratus](https://github.com/nnmrts)
 * @since 0.1.0
 */
class App extends Component {
	state = {
		navCollapsed: true,
		ticketsVisible: false
	};

	toggleNav = () => {
		this.setState({
			navCollapsed: !this.state.navCollapsed,
		});
	}

	toggleTickets = () => {
		this.setState({
			ticketsVisible: !this.state.ticketsVisible,
		});
	}

	/**
	 *
	 *
	 * @returns {jsx}
	 * component
	 * @memberof App
	 * @author [Nano Miratus](https://github.com/nnmrts)
	 * @since 0.1.0
	 */
	render() {
		return (
			<Router>
				<Layout
					id="app"
					style={{
						minHeight: "100vh"
					}}
				>

					<Sider
						collapsible
						collapsed={this.state.navCollapsed}
						onCollapse={this.onCollapse}
						collapsedWidth="0"
						trigger={null}
					>
						<div
							className="logo" />
						<Menu
							theme="dark"
							defaultSelectedKeys={[
								"0"
							]}
							mode="inline"
						>
							{(() => routes.map((route, i) => (
								<MenuItem
									key={i}
								>
									<Link
										key={i}
										to={route.path}
									>
										<span>{route.text}</span>

									</Link>
								</MenuItem>
							)))()}
						</Menu>
					</Sider>
					<Layout>
						<Content
							style={{
								height: "100%"
							}}
						>
							<StyledButton
								type="primary"
								shape="circle"
								onClick={this.toggleNav}
								className={this.state.navCollapsed ? "collapsed" : ""}
								size="large"
							>
								<Icon
									type={this.state.navCollapsed ? "menu-unfold" : "menu-fold"} />
							</StyledButton>
							<TransitionGroup
								style={{
									height: "100%"
								}}
							>
								<CSSTransition
									key={window.location.key}
									classNames="fade"
									timeout={300}
								>
									<Switch
										location={window.location}
									>

										<RouteList />
									</Switch>
								</CSSTransition>
							</TransitionGroup>

							<TicketsButton
								onClick={this.toggleTickets}
								size="large"
							>
								Tickets
							</TicketsButton>
							<Modal
								title="Tickets"
								visible={this.state.ticketsVisible}
								footer={null}
								onOk={this.toggleTickets}
								onCancel={this.toggleTickets}
							>
								<Table
									showHeader={false}
									columns={ticketColumns}
									dataSource={tickets}
									pagination={false}
									size="small" />
							</Modal>
						</Content>
					</Layout>

				</Layout>
			</Router>
		);
	}
}

/**
 *
 *
 * @param {any} state
 * state
 * @returns {object}
 * props
 */
const mapStateToProps = state => ({
	translate: getTranslate(state.locale),
	currentLanguage: getActiveLanguage(state.locale).code
});

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/app.js